let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gjDHC")).then(() => parcelRequire('cRIcG'));